@if (variant === 'bar') {
  <div
    class="owner-block-bar"
    [matMenuTriggerFor]="blockMenu"
    (click)="onCardClick($event)"
    (mouseenter)="onCardMouseEnter()"
    (mouseleave)="onCardMouseLeave()">
    <span class="owner-block-preview-lock small"></span>
    @if (showLabel) {
      <tidy-text [body]="'Blocked'" />
    }
  </div>
} @else if (variant === 'row') {
  <div
    class="owner-block-row"
    [matMenuTriggerFor]="blockMenu"
    (click)="onCardClick($event)"
    (mouseleave)="onCardMouseLeave()">
    <div>
      <tidy-text [body]="'• ' + (address || '')" />
      <tidy-text [helper]="' (' + block.title + ')'" />
    </div>
    @if (block.reason) {
      <div class="row-reason">
        <tidy-text [helper]="block.reason | escapeHtml" />
      </div>
    }
  </div>
} @else {
  <div
    class="owner-block-card"
    [class.size-sm]="size === 'sm'"
    [class.size-md]="size === 'md'"
    [matMenuTriggerFor]="blockMenu"
    (click)="onCardClick($event)"
    (mouseenter)="onCardMouseEnter()"
    (mouseleave)="onCardMouseLeave()">
    <div class="card-body">
      <span class="lock-badge">
        <span class="lock-icon"></span>
      </span>
      <span class="range-label">{{ block.title }}</span>
      @if (nightsLabel) {
        <span class="nights-pill">{{ nightsLabel }}</span>
      }
    </div>
  </div>
}

<mat-menu
  #blockMenu="matMenu"
  class="owner-block-popover-menu"
  xPosition="after"
  [hasBackdrop]="!isDesktop">
  <div
    class="owner-block-popover"
    (click)="$event.stopPropagation()"
    (mouseenter)="onPopoverMouseEnter()"
    (mouseleave)="onPopoverMouseLeave()">
    <div class="popover-header">
      <span class="lock-badge lg">
        <span class="lock-icon"></span>
      </span>
      <div class="header-text">
        <tidy-text [header]="'Blocked Dates'" />
        @if (address) {
          <tidy-text [helper]="address" />
        }
      </div>
    </div>
    <tidy-card class="secondary-layer no-margin">
      <div class="detail-row">
        <tidy-image [src]="'assets/svg/calendar-outline.svg'" class="detail-icon" />
        <tidy-text [body]="block.title" />
      </div>
      <div class="detail-row">
        <tidy-image [src]="'assets/svg/moon-outline.svg'" class="detail-icon" />
        <tidy-text [body]="nightsLongLabel" />
      </div>
      @if (block.reason) {
        <div class="detail-row reason-row">
          <tidy-image [src]="'assets/svg/create-outline.svg'" class="detail-icon" />
          <tidy-text [body]="block.reason | escapeHtml" />
        </div>
      }
    </tidy-card>
    <div class="popover-hint">
      <tidy-text [helper]="'Guests can\'t book these dates.'" />
    </div>
    <div class="actions-row">
      <tidy-button
        class="secondary"
        [smallBody]="true"
        [text]="'Edit'"
        [image]="'assets/svg/create-outline.svg'"
        [action]="edit.bind(this)" />
      <tidy-button
        class="secondary"
        [smallBody]="true"
        [text]="'Unblock Dates'"
        [image]="'assets/svg/lock-open-outline.svg'"
        [action]="unblock.bind(this)" />
    </div>
  </div>
</mat-menu>
